import { TextField } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import React, { useState } from 'react';

const onKeyDown = (e) => {
    e.preventDefault();
};

const renderError = (formik, keyField) => {
    let keyFieldParts = keyField?.split('.');
    
    if(keyFieldParts?.length === 3 && formik?.errors[keyFieldParts[0]]) {
        let errorString = formik?.errors[keyFieldParts[0]]?.[keyFieldParts[1]]?.[keyFieldParts[2]];
        return   <div>
                    { errorString ? <div className="error-text">{errorString}</div>: null }
                 </div>
    }
    else {
        return <div>{formik?.errors[keyField] ? <div className="error-text">{formik?.errors[keyField]}</div> : null}</div>
    }
}

//const ageLimit = moment().subtract(10, "years")
function DateSelector({ keyField, formik, label, minDate = moment().subtract(200, "years"), maxDate = moment(), required = true, hasValue = false, readOnly = false }) {
    const [value, setValue] = useState(hasValue || "");
    const [open, setOpen] = useState(false)
    const handleChange = (val) => {
        formik.setFieldValue(keyField, moment(val).format("MM/DD/YYYY"));
        setValue(val);
    };
    //useEffect(() => {
    //    !hasValue && formik.setFieldValue(keyField, moment(ageLimit).format("MM-DD-YYYY"));
    //    // eslint-disable-next-line react-hooks/exhaustive-deps
    //}, [])
    return (
        <div className="field-wrap createPatientDOB">
            <label htmlFor={keyField}>
                {label}
                {required ? <span style={{ color: "red" }}> *</span> : " (Optional)"}
            </label>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                    label={false}
                    inputFormat="MM-DD-YYYY"
                    minDate={minDate}
                    maxDate={maxDate}
                    value={hasValue ? moment(formik.values[keyField], "MM-DD-YYYY") : value}
                    onChange={handleChange}
                    readOnly={readOnly}
                    closeOnSelect
                    onOpen={() => !readOnly && setOpen(true)}
                    onClose={() => !readOnly && setOpen(false)}
                    open={open}
                    renderInput={(params) => 
                        <TextField
                            {...params}
                            onKeyDown={onKeyDown}
                            onBeforeInput={onKeyDown}
                            // onClick={() => !readOnly && setOpen(true)}  {...params} error={false} 
                            inputProps={{
                                ...params.inputProps,
                                style: { textTransform: 'uppercase' } // Change text to uppercase
                            }}
                        />
                    }
                />
            </LocalizationProvider>
            <div>{formik?.touched[keyField] && formik?.errors[keyField] ? <div className="error-text">{formik?.errors[keyField]}</div> : null}</div>
        </div>
    )
}

export default DateSelector



export function DateSelectorWithoutFormik({componentName="", type, formik, keyField, isError = "", handleChange, onOpen, value, label, required = true, minDate, maxDate,readOnly = false, hideRequired= false, ...props  }) {
    const [open, setOpen] = useState(false)

    const handleKeyDown = (event) => {       
        if (event.keyCode === 8 && handleChange) {            
            handleChange(null);
        }
    };
    
    return (
        <div className="field-wrap createPatientDOB">
            {label ? <label>
                {label}
                {hideRequired ? null : required ? <span style={{ color: "red" }}> *</span> : " (Optional)"}
            </label> : null}
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                    // label={label}
                    className={componentName}
                    value={formik?.values?.[keyField] || value}
                    inputFormat='MMM-DD-YYYY'
                    minDate={minDate}
                    maxDate={maxDate}
                    onChange={(value)=>{setOpen(false);handleChange(value)}}
                    readOnly={readOnly}
                    onKeyDown={handleKeyDown}
                    {...props}
                    closeOnSelect
                    onOpen={() => {!readOnly && setOpen(true); if (onOpen) onOpen()}}
                    onClose={() => !readOnly && setOpen(false)}
                    open={open}
                    sx={{
                        ".MuiInputBase-root": {
                            borderRadius: "10px",
                         },
                         ".MuiFilledInput-input": {
                            padding: "16.5px 14px",
                         }
                    }}
                    renderInput={(params) => 
                            <TextField
                                value={formik?.values?.[keyField] || value}
                                {...params}
                                placeholder="YYYY-MM-DD"
                                inputProps={{
                                    ...params.inputProps,
                                    readOnly: type === "readonly" ?  true : false,
                                    style: { textTransform: 'uppercase' } // Change text to uppercase
                                }}
                                
                                onBeforeInput={handleKeyDown}
                                onKeyDown={handleKeyDown}
                                // onClick={() => !readOnly && setOpen(true)}  
                                error={false} 
                            />
                    }
                />
            </LocalizationProvider>
            {/* <div>{isError ? <div className="error-text">{isError}</div> : null}</div> */}
            {
                renderError(formik, keyField)
            }
        </div>
    )
}
